export const category = [
  {
    img: "https://jaxsonmaximus.com/cdn/shop/articles/Screenshot_2025-01-09_at_12.16.03_PM_7c991729-02c2-4299-a71e-092b32a40f43.png?v=1736443439&width=1340",
    name: "Casual Wear",
    off: "20-40% OFF",
  },
  {
    img: "https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/24439364/2023/8/10/a157968c-bc17-4fa8-b805-31f930c47b381691681709790MenBlackSolidSlimFitFormalBlazer1.jpg",
    name: "Formal Wear",
    off: "10-20% OFF",
  },
  {
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqR8nb8uO-HERwcu2eIWBFaSY7DC_KaX19hvBNApYgTgacS1Hhhx8WJOY_-jacJnwzXqY&usqp=CAU",
    name: "Winter Wear",
    off: "20-40% OFF",
  },
  {
    img: "https://images.bewakoof.com/utter/content/2484/content_western_dress_3.jpg",
    name: "Western Wear",
    off: "30-40% OFF",
  },
  {
    img: "https://assets0.mirraw.com/images/11782208/3283579_long_webp.webp?1696934926",
    name: "Ethnic Wear",
    off: "10-40% OFF",
  },
];

export const filter = [
  {
    name: "Product Categories",
    value: "category",
    items: [
      "Men",
      "Women",
      "Kids",
      "Bags",
      "Accessories",
      "Casual Wear",
      "Formal Wear",
      "Winter Wear",
      "Ethnic Wear",
    ],
  },
  {
    name: "Filter by Price",
    value: "price",
    items: [],
  },
  {
    name: "Filter by Size",
    value: "size",
    items: ["S", "M", "L", "XL", "XXL"],
  },
];
